import React, { useState, useRef } from 'react'
import moment from 'moment'
import { FormControl, Typography, Accordion, AccordionSummary, AccordionDetails, TextField, Box, Popover, IconButton, Button, Grid } from '@mui/material';
import { ReactComponent as DropDownIcon } from "../../../assets/icons/icon-angle-down.svg"
import { makeStyles } from '@mui/styles'
import DatePicker from "react-datepicker";


const useStyles = makeStyles(theme => ({
    formControl: {
        margin: theme.spacing(1),
        minWidth: "10%",
        width: "100"
    },
    graphFiltergrid: {
        [theme.breakpoints.down('sm')]: {
            marginTop: '0rem',
            '& > .MuiGrid-item': {
                paddingTop: 0,
            },
        },
    },
    inputLabel: {
        minHeight: '21px',
    }
}))

export default function FilterDateRange({ obj, i, handleDateFilter, reportIndex, showLabel = true }) {
    const classes = useStyles();
    const [filterInputEl, setFilterInputEl] = React.useState(null);
    const [filterInputOpen, setFilterInputOpen] = React.useState(false);
    const filterInputId = filterInputOpen ? 'simple-popover' : undefined;
    const selectFiltersInput = useRef(null);
    const [selectFilterWidth, setSelectFilterWidth] = useState('200px');
    const handleFilterInputClick = (event) => {
        setSelectFilterWidth(selectFiltersInput.current.clientWidth);
        if (event.currentTarget != filterInputEl) {
            setFilterInputEl(event.currentTarget);
        }
        if (!filterInputOpen) {
            setFilterInputOpen(true);
        } else {
            setFilterInputOpen(false);
        }
    };
    const handleFilterInputClose = () => {
        setFilterInputEl(null);
        setFilterInputOpen(false);
    };


    return (
        <FormControl variant="outlined" sx={{ width: '100%' }} size="small">
            {showLabel ? <Typography className={classes.inputLabel + " report-form-label"} variant="subtitle1" > {obj?.displayName} </Typography> : null}
            {/* <Accordion className="filter_accordian">
                <AccordionSummary
                    className="filter_accordian_summary "
                    expandIcon={<DropDownIcon />}
                    aria-controls="panel1a-content"
                    id="panel1a-header"
                >
                    <Typography className="report-form-label" variant="subtitle1" > Date </Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography className="report-form-label" variant="subtitle2" >Start Date</Typography>

                    <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss"  showTimeSelect className="report_form_ui_input_date" selected={obj?.values[0] && moment(obj?.values[0]).toDate()} onChange={(e) => handleDateFilter(e, obj, i, 'startDate', reportIndex)}
                    isClearable
                     />
                    <Typography className="report-form-label" variant="subtitle2" >End Date</Typography>

                    <DatePicker dateFormat="dd/MM/yyyy HH:mm:ss" showTimeSelect className="report_form_ui_input_date" selected={obj?.values[0] && moment(obj?.values[0]).toDate()} onChange={(e) => handleDateFilter(e, obj, i, 'endDate', reportIndex)} isClearable/>
                </AccordionDetails>
            </Accordion> */}
            <Box className="select_filters_input border-input" onClick={handleFilterInputClick} ref={selectFiltersInput} >
                <Box className="select_filters_input_item" display="flex" alignItems="center">
                    <Typography variant="body2" className="label-font">
                    {
                        obj?.values && obj?.values?.length && obj?.values?.[0] && obj?.values?.[1] ? (
                        `${obj?.values?.[0] ? moment(obj?.values[0]).format('DD/MMM/yyyy') : ''} 
                        ${obj?.values?.[1] ? ' - '+ moment(obj?.values[1]).format('DD/MMM/yyyy') : ''}`
                        ) : 'Select Date Range'
                    }
                    </Typography>
                </Box>
                <Box className="select_filters_input_item"><DropDownIcon /></Box>
            </Box>
            <Popover
                id={filterInputId}
                open={filterInputOpen}
                anchorEl={filterInputEl}
                onClose={handleFilterInputClose}
                anchorOrigin={{
                    vertical: 'bottom',
                    horizontal: 'left',
                }}
                PaperProps={{
                    classes: {
                        root: 'filter-item-options mt-0'
                    }
                }}
            >
                <Box className="filters-dropdown-item" sx={{ width: selectFilterWidth }}>
                    <Box className="filters-dropdown-item-content" sx={{ p: '1rem !important' }}>
                        <Grid container spacing={2} >
                            <Grid xs={12} md={6} item >
                                <Typography className="report-form-label text-plain" variant="subtitle2" >Start Date</Typography>
                                <DatePicker 
                                autoComplete='off'
                                dateFormat="dd-MM-yyyy"  className="report_form_ui_input_date" selected={obj?.values[0] ? new Date(obj?.values[0]): null} onChange={(e) => handleDateFilter(e, obj, i, 'startDate', reportIndex)} 
                                isClearable placeholderText='Select Date' />
                            </Grid>
                            <Grid xs={12} md={6} item >
                                <Typography className="report-form-label text-plain" variant="subtitle2" >End Date</Typography>
                                <DatePicker 
                                autoComplete='off'
                                dateFormat="dd-MM-yyyy" 
                                maxDate={new Date()} 
                                className="report_form_ui_input_date" selected={obj?.values[1] ? new Date(obj?.values[1]): null} onChange={(e) => handleDateFilter(e, obj, i, 'endDate', reportIndex)} 
                                isClearable placeholderText='Select Date'/>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Popover>
        </FormControl>
    )
}
